import { SoundCloudVersion } from 'types/releases';
import { useAppDispatch } from 'app/store';
import { useEffect, useMemo, useState } from 'react';
import { ReorderBody } from 'app/components/DraggableListRow/types';
import { moveReleaseVersionEffect } from 'app/store/Releases/effects';
import { useDraggableRowRenderer } from 'app/components/DraggableListRow/hooks';

export const useVersionsListReorder = (versions: SoundCloudVersion[]) => {
  const dispatch = useAppDispatch();
  const [rows, setRows] = useState<SoundCloudVersion[]>(versions);

  const draggableRows = useMemo(
    () =>
      rows.map((row) => ({
        ...row,
        tooltip: row.title || row.song.title,
      })),
    [rows]
  );

  const onReorder = async (data: ReorderBody) => {
    const result = await dispatch(
      moveReleaseVersionEffect({
        versionGuid: data.guid,
        afterVersionGuid: data.afterGuid,
      })
    );
    return result.type === `${moveReleaseVersionEffect.typePrefix}/fulfilled`;
  };

  const {
    RowRenderer,
    tooltipTitle,
    onRowReorder,
    onDragging,
  } = useDraggableRowRenderer<SoundCloudVersion>({
    rows: draggableRows,
    setRows,
    onReorder,
  });

  useEffect(() => {
    setRows(versions);
  }, [versions]);

  return {
    RowRenderer,
    tooltipTitle,
    setRows,
    rows,
    onRowReorder,
    onDragging,
  };
};
